import React, { Component, Fragment } from 'react'
import { Translate } from '../../contexts/Language';
import { Card, BreadCrumb, Modal, JsonTable, Confirm } from '../../components';
import "react-datepicker/dist/react-datepicker.css";
import DataTable from 'react-data-table-component'
import { DataTableColumns } from '../../config/DataTableColumns';
import { Service } from '../../services';
import { Config } from '../../config';
import DataTableExtensions from 'react-data-table-component-extensions';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import { isArray } from 'util';
import { Button, Input } from 'reactstrap';
import { ErrorMessage } from '../../components/Validator';



let beginDate = localStorage.getItem("beginDate"),
    endDate = localStorage.getItem("endDate");

export class Withdrawal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            confirmModal: false, cancelModal: false,
            transactionId: null,
            formData: {
                beginDate: (beginDate ? new Date(beginDate) : new Date()),
                endDate: (endDate ? new Date(endDate) : new Date()),
                status: -5,
                comment: "",
                digitCode: '', // Kullanıcının gireceği TFA kodu
            },
            dataTable: {
                columns: DataTableColumns.withdrawal,
                rows: []
            },
            modal: false,
            detail: {},
            readOnly: true,
            validation: {
                error: false,
                message: ""
            },
            validation2: {
                error: true,
                message: ""
            },
            tfaConfirmValidation: {
                error: false,
                message: ""
            },
            tfaCancelValidation: {
                error: false,
                message: ""
            }
        }

        this.onDetail = this.onDetail.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);
        this.onEditSave = this.onEditSave.bind(this);
        this.onPending = this.onPending.bind(this);
        this.onConfirm = this.onConfirm.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onDateChange = this.onDateChange.bind(this);

    }

    componentDidMount() {
        this.onFilter();
    }
    onFilter() {
        Config.utilities.loadingFetch();

        const formData = Object.assign({}, this.state.formData);
        let beginDate = new Date(formData.beginDate);
        formData.beginDate = new Date(beginDate.setDate(beginDate.getDate() + 1));

        Service.Withdraw.History(formData).then(response => {

            if (response) {

                let dataTable = this.state.dataTable;

                dataTable.rows = response;

                this.setState({
                    dataTable: dataTable
                });

            }

            Config.utilities.loadingFetch();
        });
    }
    onDateChange(date) {

        let tempData = this.state.formData;

        if (date !== null && isArray(date)) {
            tempData["beginDate"] = date[0];
            tempData["endDate"] = date[1];
        }
        else {
            tempData["beginDate"] = "";
            tempData["endDate"] = "";
        }
        this.setState({
            formData: tempData
        });
        localStorage.setItem("beginDate", tempData["beginDate"]);
        localStorage.setItem("endDate", tempData["endDate"]);
    }
    onChange(value, stateKey) {

        let tempData = this.state.formData;

        tempData[stateKey] = value

        this.setState({
            formData: tempData
        });

        localStorage.setItem(stateKey, value);
    }
    onCloseModal() {
        this.setState({
            modal: false,
            readOnly: true
        })
    }
    
    handleConfirmWithdrawTFAverify = (e) => {
        e.preventDefault();
        const { digitCode } = this.state.formData;
        const { formData, transactionId } = this.state;
        
        // TFA kodu doğrulama isteği gönder-
        Config.utilities.loadingFetch();
        Service.User.WithdrawVerify2FA({ DigitCode: digitCode }).then(response => {
            if (response && !response.error && response.dataVerify) {
                this.setState(prev=>({formData: { ...prev.formData,digitCode: '' }, tfaConfirmValidation:{error:false,message: ""}}))
                // TFA başarılıysa çekim işlemini onayla
            Service.Withdraw.Confirm({ 'TransactionId': this.state.transactionId, 'Type': "withdrawal" }).then((response) => {
              if (response && !response.error) {
                this.setState({
                  readOnly: true,
                  confirmModal: false,  // Modalı kapat
                  validation: response,
                  validation2: response, // Validation güncelle
                });
                this.onFilter(); // Filtreyi yeniden uygula
                Config.utilities.loadingFetch();
              }

            })} 
            else {
            this.setState({tfaConfirmValidation:{error:true,message: "Wrong 2FA Code"}})
            Config.utilities.loadingFetch();
          }
        });
      };

      handleCancelWithdrawTFAverify = (e) => {
        e.preventDefault();
        const { digitCode } = this.state.formData;
        const { formData, transactionId } = this.state;
        
        // TFA kodu doğrulama isteği gönder-
        Config.utilities.loadingFetch();
        Service.User.WithdrawVerify2FA({ DigitCode: digitCode }).then(response => {
            if (response && !response.error && response.dataVerify) {
                this.setState(prev=>({formData: { ...prev.formData,digitCode: '' }, tfaCancelValidation:{error:false,message: ""}}))
                // TFA başarılıysa çekim işlemini onayla
                Service.Withdraw.Cancel({ 'TransactionId': transactionId, 'Type': "withdrawal" }).then(response => {

                    if (response && !response.error) {
                        
                        this.setState({
                            readOnly: true,
                            cancelModal: false,
                            validation: response,
                            validation2:response
                        })
                        this.onFilter();
                        Config.utilities.loadingFetch();
                    }

                })}
                else {
                    this.setState({tfaCancelValidation:{error:true,message: "Wrong 2FA Code"}})
                    Config.utilities.loadingFetch();
                  }
                });
              };
    onConfirm(transactionId) {
        this.setState({ confirmModal: true, transactionId  })
        // Confirm({
        //     title: Translate("Are you sure?"),
        //     type: { warning: true },
        //     description: Translate("This withdrawal will be confirmed"),
        //     onConfirm: () => {
        //         Config.utilities.loadingFetch();
        //         Service.Withdraw.Confirm({ 'TransactionId': transactionId, 'Type': "withdrawal" }).then(response => {

        //             if (response) {
        //                 this.setState({
        //                     readOnly: true,
        //                     modal: false,
        //                     validation: response,
        //                     validation2:response
        //                 })
        //                 this.onFilter();
        //             }

        //             Config.utilities.loadingFetch();
        //         });

        //     },
        //     onCancel: () => {

        //     }
        // });
    }

    onDetail(transactionId) {
        Config.utilities.loadingFetch();

        Service.Withdraw.Detail({ "TransactionId": transactionId }).then(response => {

            if (response) {
                if (response.common !== null)
                    response.common = JSON.parse(response.common);

                if (response.requestHeader !== null)
                    response.requestHeader = JSON.parse(response.requestHeader);

                if (response.comment !== null) {
                    let comment = JSON.parse(response.comment);
                    response.comment = comment.Comment;
                }

                if (response.transferDetail != null) {
                    response.transferDetail = JSON.parse(response.transferDetail);
                }

                let formData = this.state.formData;
                formData.comment = response.comment;

                this.setState({
                    detail: response,
                    formData: formData,
                    modal: true
                });

            }

            Config.utilities.loadingFetch();
        });
    }
    onCancel(transactionId) {
        this.setState({ cancelModal: true, transactionId  })
        // Confirm({
        //     title: Translate("Are you sure?"),
        //     type: { warning: true },
        //     description: Translate("This withdrawal will be canceled"),
        //     onConfirm: () => {
        //         Config.utilities.loadingFetch();
        //         Service.Withdraw.Cancel({ 'TransactionId': transactionId, 'Type': "withdrawal" }).then(response => {

        //             if (response) {
        //                 this.setState({
        //                     readOnly: true,
        //                     modal: false,
        //                     validation: response,
        //                     validation2:response
        //                 })
        //                 this.onFilter();
        //             }

        //             Config.utilities.loadingFetch();
        //         });
        //     },
        //     onCancel: () => {

        //     }
        // });
    }
    onEditSave() {
        if (this.state.readOnly) {
            this.setState({
                readOnly: false
            })
        }
        else {

            Config.utilities.loadingFetch();

            Service.Withdraw.SaveComment({ 'TransactionId': this.state.detail.transactionId, 'Comment': this.state.formData.comment, 'Type': "withdrawal" }).then(response => {

                if (response) {
                    this.setState({
                        readOnly: true,
                        modal: false
                    })
                }

                Config.utilities.loadingFetch();
            });
        }
    }
    onPending() {

        Confirm({
            title: Translate("Are you sure?"),
            type: { warning: true },
            description: Translate("This withdrawal will be pending"),
            onConfirm: () => {
                Config.utilities.loadingFetch();
                Service.Withdraw.Pending({ 'TransactionId': this.state.detail.transactionId, 'Type': "withdrawal" }).then(response => {

                    if (response) {
                        this.setState({
                            readOnly: true,
                            modal: false,
                            validation: response,
                            validation2:response
                        })
                        this.onFilter();
                    }

                    Config.utilities.loadingFetch();
                });
            },
            onCancel: () => {

            }
        });
    }

    onFormChange(value, key) {

        let formData = this.state.formData;

        formData[key] = value;

        this.setState({
            formData
        });
    }
    
    render() {
        return (
            <Fragment>
                
                <BreadCrumb Title={Translate("Withdrawal")} Name={Translate("Withdrawal")} />

                {this.state.confirmModal && <Modal Title={Translate("2FA Confirm")} centered={true} smallSize={true}  Show={this.state.confirmModal}  onClose={(e) => this.setState(prev=>({ formData: { ...prev.formData,digitCode: '' },tfaConfirmValidation: { error: false, message: "" },confirmModal: false }))}>
                    <form onSubmit={this.handleConfirmWithdrawTFAverify} style={{ display: "flex",flexDirection:"column" }}>
                            {/* Kod doğrulama kısmı */}
                            <ErrorMessage Validation={this.state.tfaConfirmValidation}  />
                            <div style={{display: 'flex', flexDirection: 'column', marginBottom: '20px'}}>
                                <label htmlFor="digitCode">Enter the code from your authenticator app:</label>
                                <Input
                                    type="text" 
                                    id="confirmDigitCode" 
                                    name="confirmDigitCode" 
                                    required
                                    minlength="6"
                                    maxlength="6"
                                    value={this.state.formData.digitCode}
                                    // onChange={(e) => this.onFormChange(e.target.value, "digitCode")} 
                                    onChange={(e) => {const {value} = e.target;this.setState(prev=>({ formData: { ...prev.formData, digitCode: value} }))}} 
                                />
                                
                            </div>
                            
                           
                            <Button style={{alignSelf:"end"}} className='btn-primary' type="submit">Verify2FA Code</Button>
                            </form>
                </Modal>}
                {this.state.cancelModal && <Modal Title={Translate("2FA Cancel")} centered={true} smallSize={true}  Show={this.state.cancelModal}  onClose={(e) => this.setState(prev=>({ formData: { ...prev.formData,digitCode: '' },tfaCancelValidation: { error: false, message: "" },cancelModal: false }))}>
                    <form onSubmit={this.handleCancelWithdrawTFAverify} style={{ display: "flex",flexDirection:"column" }}>
                            {/* Kod doğrulama kısmı */}
                            <ErrorMessage Validation={this.state.tfaCancelValidation}  />
                            <div style={{display: 'flex', flexDirection: 'column', marginBottom: '20px'}}>
                                <label htmlFor="digitCode">Enter the code from your authenticator app:</label>
                                <Input
                                    type="text" 
                                    id="cancelDigitCode" 
                                    name="cancelDigitCode" 
                                    required
                                    minlength="6"
                                    maxlength="6"
                                    value={this.state.formData.digitCode}
                                    // onChange={(e) => this.onFormChange(e.target.value, "digitCode")} 
                                    onChange={(e) => {const {value} = e.target;this.setState(prev=>({ formData: { ...prev.formData, digitCode: value} }))}} 
                                />
                                
                            </div>
                            
                           
                            <Button style={{alignSelf:"end"}} className='btn-primary' type="submit">Verify2FA Code</Button>
                            </form>
                </Modal>}

                <Modal Title={Translate("Withdrawal Detail")} Show={this.state.modal} onClose={this.onCloseModal} Status={this.state.detail.statusTitle} onPending={this.onPending} Withdraw>
                    <div className="row mt-1 mb-1">
                        <p className="text-muted mb-2 ml-1 col-md-12 font-12">{Translate("Transfer Information")} [#{this.state.detail.id}]</p>
                        <div className="col-md-6">
                            <dl className="row mb-0 ml-1 dl-striped">
                                <dt className="col-sm-6">{Translate('Status')}</dt>
                                <dd className="col-sm-6"><span className={"badge pb-1 font-12 payment-status " + this.state.detail.statusClass}>{Translate(this.state.detail.statusTitle)}</span></dd>
                                <dt className="col-sm-6">{Translate('Login')}</dt>
                                <dd className="col-sm-6">{this.state.detail.login}</dd>
                                <dt className="col-sm-6">{Translate('PSP')}</dt>
                                <dd className="col-sm-6"><img src={"/assets/psp-logo/" + this.state.detail.transferLogo} alt="" width="16" className="mb-1" />&nbsp; {this.state.detail.transferOption}</dd>
                                <dt className="col-sm-6">{Translate('Amount')}</dt>
                                <dd className="col-sm-6">{this.state.detail.amount + " " + this.state.detail.transferCurrency}</dd>
                            </dl>
                        </div>
                        <div className="col-md-6">
                            <dl className="row mb-0 ml-1 mr-1 dl-striped">
                                <dt className="col-sm-6">{Translate('Date')}</dt>
                                <dd className="col-sm-6">{this.state.detail.insertDate}</dd>
                                <dt className="col-sm-6">{Translate('Fullname')}</dt>
                                <dd className="col-sm-6">{this.state.detail.fullname}</dd>
                                <dt className="col-sm-3">{Translate('Comment')}</dt>
                                <dd className="col-sm-9">
                                    <div className="input-group input-group-sm">
                                        <textarea className="form-control input-sm" type="text" id="comment" name="comment" onChange={(e) => this.onChange(e.target.value, "comment")} onFocus={e => e.target.select()} readOnly={this.state.readOnly}>
                                            {this.state.formData.comment}
                                        </textarea>
                                        <div className="input-group-append hide">
                                            <button type="button" className="input-group-text pt-0 pb-0 bg-info text-white btn-sm" id="availableMargin" onClick={(e) => this.onEditSave()}>
                                                {this.state.readOnly ? Translate("Edit") : Translate("Save")}
                                            </button>
                                        </div>
                                    </div>
                                </dd>
                            </dl>
                        </div>

                        {this.state.detail.common != null ?
                            <Fragment>
                                <p className="text-muted mb-2 mt-3 ml-1 col-md-12 font-12">{Translate("Common Information")}</p>
                                <div className="col-md-6">
                                    <dl className="row mb-0 ml-1 dl-striped">
                                        {Object.keys(this.state.detail.common).map(key => (
                                            <Fragment>
                                                <dt className="col-sm-4 text-capitalize">{key.replace(/_/g, " ")}</dt>
                                                <dd className="col-sm-8">{this.state.detail.common[key]}</dd>
                                            </Fragment>
                                        ))}
                                    </dl>
                                </div>
                            </Fragment>
                            : ""}


                        {this.state.detail.requestHeader ?
                            <Fragment>
                                <p className="text-muted mb-2 mt-3 ml-1 col-md-12 font-12">{Translate("Request Header")} &nbsp;</p>
                                <div className="col-md-12">
                                    <JsonTable Data={[this.state.detail.requestHeader]} />
                                </div>
                            </Fragment> : ""}

                        {this.state.detail.transferDetail != null ?
                            <Fragment>
                                <p className="text-muted mb-2 mt-3 ml-1 col-md-12 font-12">{Translate("Transfer Detail")}</p>
                                <div className="col-md-6">
                                    <dl className="row mb-0 ml-1 dl-striped">
                                        {Object.keys(this.state.detail.transferDetail).map(key => (
                                            <Fragment>
                                                <dt className="col-sm-4 text-capitalize">{key.replace(/_/g, " ")}</dt>
                                                <dd className="col-sm-8">{this.state.detail.transferDetail[key]}</dd>
                                            </Fragment>
                                        ))}
                                    </dl>
                                </div>
                            </Fragment>
                            : ""}
                    </div>
                </Modal>
                <Card Title="Customer Withdrawals" Description="History of withdrawals">
                    <div className="row mb-3">
                        <div className="col-md-2">
                            <div className="form-group mb-0">
                                <label>Status</label>
                                <select className="form-control" name="status" id="status" onChange={(e) => this.onChange(e.target.value, "status")}>
                                    <option value="-5">All</option>
                                    <option value="-4">Failed</option>
                                    <option value="-3">Error</option>
                                    <option value="-2">Temp</option>
                                    <option value="-1">Cancel</option>
                                    <option value="0">Pending</option>
                                    <option value="1">Confirm</option>
                                    <option value="2">Manual</option>
                                    <option value="3">Processing</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group mb-0">
                                <label>Date Range</label>
                                <div>
                                    <DateRangePicker className="date-range-picker form-control"
                                        onChange={this.onDateChange}
                                        value={[this.state.formData.beginDate, this.state.formData.endDate]}
                                        format={"dd.MM.yyyy"}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="form-group mb-0">
                                <label>&nbsp;</label>
                                <button type="button" className="btn btn-dark bg-dark btn-block" onClick={e => this.onFilter(e)}>Filter History</button>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className={"col-md-12 " + (this.state.validation.error ? "" : "d-none")}>
                            <div className={"alert alert-danger alert-dismissible fade mb-0 show"} role="alert">
                                <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <strong>{Translate("Error !")}</strong> {this.state.validation.message}
                            </div>
                        </div>
                        <div className={"col-md-12 " + (this.state.validation2.error ? "d-none" : "")}>
                            <div className={"alert alert-success alert-dismissible fade mb-0 show"} role="alert">
                                <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <strong>{Translate("success ! ")}</strong> {this.state.validation2.message}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            {this.state.dataTable.rows.length === 0 ? (
                                <div className="alert alert-light" role="alert">
                                    <em><strong>No record!</strong> {Translate('No records found for the filter.')} </em>
                                </div>) :
                                (
                                    <DataTableExtensions columns={this.state.dataTable.columns(this.onConfirm, this.onCancel, this.onDetail)} data={this.state.dataTable.rows} exportHeaders={true}>
                                        <DataTable
                                            noHeader={true}
                                            defaultSortField="id"
                                            defaultSortAsc={false}
                                            className="no-scroll"
                                            pagination
                                            highlightOnHover />
                                    </DataTableExtensions>)}
                        </div>
                    </div>
                </Card>
            </Fragment>
        )
    }
}